// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Intl_pageHeader__1nnIC"};